
export default {
  data() {
    return {
      keywordId: '',
      keywordType: '',
      keywordName: '',

      section_flag: '',
      tableData: [{
        id: '',
        name: '',
        page: '',
        shop_id: '',
        sort: '',
        template: '',
        product: [{
          name: '',
          id: '',
        }]
      }],
      product: [{
        attr: '',
        cer_industry: null,
        cer_year: '',
        desc: '',
        id: '',
        image: '',
        is_auth: '',
        name: '',
        onsale: '',
        period: '',
        price: '',
        project_id: '',
        shop_name: '',
        teacher: '',
        teacher_intro: '',

      }],
      form: {},
      multipleSelection: [],
      input1: '',
      select: '',
      dialogTableVisible: false,
      options4: [],
      list: [],
      listPush: [],//选中列表副本
      loading: false,
      formSelected: [],
      loadSelected: [],
      templateSelected: [{
        value: '3',
        label: '推荐模板'
      }, {
        value: '1',
        label: '普通模板'
      }, {
        value: '5',
        label: '项目包模板(一行两个)'
      }, {
        value: '4',
        label: '项目包模板(一行四个)'
      }],
      pageSelected: [{
        value: '0',
        label: '课程云超市'
      }, {
        value: '1',
        label: '项目式'
      }],
      product: [],
      //查询
      search: '',
      dialogFormVisible: false,
      formLabelWidth: '200px',
      addFlag: 0,
      dialogFormRead: false,
      dialogProd: false,
      // 分页
      totalProduct: 1,
      productLen: 15,
      offset: 0,
      currentPage: 1,
      totalPage: '',
      //当前弹出板块的产品数组
      currentProducts: [],
      //当前选到的产品
      currentSelectdProduct: '',
      //当前板块的ID
      currentSectionId: '',

      // 当前选中的项目包
      currentSelectdProjectPackage: '',
      // 项目包数组
      projectPackageList: [],
      // 当前板块包含的项目包数组
      plateProjectPackageList: []
    }
  },

  methods: {
    getProduct() {
      this.$post('products/search', { offset: 0, length: 9999, token: this.$store.state.authority_management, shop_id: this.$store.state.store.id, onsale: '1' }).then(res => {
        this.product = res.data.result.data;
        for (let i = 0; i < res.data.result.data.length; i++) {
          let obj = {}
          // // console.log(res.data.result.data[i].name)
          obj.value = res.data.result.data[i].name
          // // console.log(obj)
          obj.codeValue = res.data.result.data[i].id
          this.list.push(obj)
          // // console.log('这是obj的值')
          // // console.log(obj)
        }
        // // console.log('list的值')
        // // console.log(this.list)
      })
    },
    getData() {
      //获取所有产品
      // this.list= [];
      this.options4 = [];

      this.listPush = [];
      //获取版块信息
      this.$post('sections/shop_search', {
        shop_id: this.$store.state.store.id,
        offset: this.offset,
        length: this.productLen,
        token: this.$store.state.authority_management,
        shop_id: this.$store.state.store.id,
        name: this.keywordName
      }).then(res => {
        // // console.log(res.data.result)
        this.tableData = res.data.result.data;
        // // console.log(this.tableData)
        this.totalProduct = res.data.result.total;
        // // console.log(this.tableData)

      })
      // .then(res1=>{
      //   // // console.log(this.tableData)
      //   for(let i = 0;i < this.tableData.length;i++){
      //     this.$post('section_products/search',{token:this.$store.state.authority_management,section_id:this.tableData[i].id}).then(res2=>{
      //       // // console.log( res2.data.result)
      //       this.tableData[i].product = res2.data.result;
      //       // if(this.tableData[i].product){
      //       //      this.listPush[i]=this.tableData[i].product.map((item,index)=>{
      //       //       return item.name;
      //       //   })
      //     //   // }
      //     //    // console.log('listPush的值')
      //     // // console.log(this.listPush)
      //       // // console.log(this.tableData[i])
      //     })
      //     // // console.log(i)


      //   }

      // })
    },
    //取消全选
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          // // console.log(row)
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    onSearch() {
      let data = {
        token: this.$store.state.authority_management,
        offset: 0,
        // id: this.keywordId,
        name: this.keywordName,
        length: this.productLen,
        shop_id: this.$store.state.store.id
      };
      // 这里调用搜索资源接口
      this.$post('sections/shop_search', data).then(res => {
        // // console.log(res)
        this.tableData = res.data.result.data
        this.totalProduct = res.data.result.total
		this.currentPage = 1
        // // console.log(tableData)
        // alert("资源序号:" + tableData[0].id + "，资源名称:" + tableData[0].name + "，资源类型:" + tableData[0].type + "，试题")
      })
    },
    //添加行数
    addLine() {
      this.form = {};
      this.dialogFormVisible = true;
      this.addFlag = 1;

    },
    handleSelectionChange(val) {
      // // console.log(val)
      this.multipleSelection = val;
    },
    handleEdit(index, row) {
      // // console.log(index, row);
    },
    //删除
    handleDelete(index, row) {
      // // console.log(index,row)
      this.$confirm('此操作将删除该活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post('sections/shop_delete', { token: this.$store.state.authority_management, id: row.id })
        this.tableData.splice(index, 1);
        this.getData();
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //增加版块
    handleAdd(index, row) {
      // // console.log(index, row);
      this.dialogTableVisible = true;
    },
    //focus
    tt() {
      this.options4 = this.list
      // // console.log('options4 的值')
      // // console.log(this.options4)
    },
    change(val) {
      // // console.log('val的值')
      // // console.log(this.product)
    },
    selectRow(val) {
      this.multipleSelection = val
      // // console.log(val)
    },
    addToFormsel() {
      // // console.log(this.currentSelectdProduct.codeValue)

      // // console.log();
      //判断有没有选到产品
      if (this.currentSelectdProduct.codeValue == '' || this.currentSelectdProduct.codeValue.toString() == 'undefined' || this.currentSelectdProduct.codeValue.toString() == 'null') {
        this.$message({
          message: '请选择一个产品！',
          type: 'error'
        })
      }

      // 判断当前板块中是否有当前选择的产品存在, 有就不添加
      let id = this.currentSelectdProduct.codeValue
      const list = this.currentProducts
      for (let i = 0; i < list.length; i++) {
        if (id == list[i].id) {
          this.$message({
            type: 'error',
            message: '当前板块已存在该产品, 请不要重复添加'
          })
          return
        }
      }

      let data = {
        token: this.$store.state.authority_management,
        section_id: this.currentSectionId,
        product_id: this.currentSelectdProduct.codeValue,
      }
      this.$post('section_products/create', data).then(res => {
        // // console.log(res.data);
        if (res.data.status == 'success') {
          this.$message({
            message: '添加产品成功！',
            type: 'success'
          })
          this.getCurrentSectionProducts(this.currentSectionId);
        } else {
          this.$message({
            message: res.data,
            type: 'error'
          })
        }
      })
      // // console.log('进入添加')
      //   let isExit
      // //  // console.log(this.product.value.value)
      //   for(let val of this.formSelected){
      //     // // console.log(val.value)

      //     if(val.value == this.product.value.value){
      //       isExit = 1
      //     }
      //   }
      //   if(!this.product.value){
      //     this.$message({
      //       showClose: true,
      //       message: '请先选择产品',
      //       type: 'warning'
      //     });
      //     return false
      //   }
      //   else if(isExit == 1){
      //     this.$message({
      //       showClose: true,
      //       message: '请不要重复添加',
      //       type: 'warning'
      //     });
      //     return false
      //   }
      //   else if(this.formSelected.length >= 10){
      //     this.$message({
      //       showClose: true,
      //       message: '最多选中10个产品',
      //       type: 'error'
      //     });
      //     return false
      //   }
      //   else if(this.formSelected.length < 10){
      //     this.formSelected.push(this.product.value);
      //   }
      // // console.log(this.formSelected)
    },
    delToFormsel(row) {
      // // console.log(row.codeValue);
      // // // console.log(this.currentSectionId)
      let data = {
        token: this.$store.state.authority_management,
        //板块的id
        section_id: row.section_id,
        //产品的id
        product_id: row.id,
      }
      //发送删除的请求
      this.$post('section_products/delete', data).then(res => {
        if (res.data.status == 'success') {
          this.$message({
            message: '删除产品成功！',
            type: 'success'
          })
          //删除成功后再次请求当前板块的产品数组
          this.getCurrentSectionProducts(row.section_id);
        } else {
          this.$message({
            message: '删除产品失败！',
            type: 'error'
          })
        }
      })
      // // console.log(index,row)
      // this.formSelected.splice(index,1);
      // // console.log(this.formSelected)
      // // console.log(this.loadSelected)
    },
    // remoteMethod (query) {
    //   // console.log('query 的值')
    //   // console.log(111)
    //   if (query !== '') {
    //     this.loading = true
    //     setTimeout(() => {
    //       this.loading = false
    //       this.options4 = this.list.filter(item => {
    //         return item.codevalue.toLowerCase()
    //           .indexOf(query.toLowerCase()) > -1
    //       })
    //     }, 200)
    //   } else {
    //     this.options4 = []
    //   }
    // },
    //编辑版块
    edit(form) {
      this.form = form;
      this.addFlag = 0;
      let data = {
        token: this.$store.state.authority_management,
        section_id: form.id
      }
      // // console.log('sasasas', form)
      this.$post('section_products/search', data).then(res => {
        // // console.log(res.data.result);
        this.form.product = res.data.result;
        this.dialogFormVisible = true;

      })

      // this.loadSelected = form.product
      // let arr=form.product.map(res=>{
      //     let json={};
      //     json.label=res.id;
      //     json.value=res.name;
      //     return json;
      // })
      // this.formSelected = arr;
      //  // console.log(arr)
      // // console.log('接收的版块信息')
      // // console.log(form);
      // // console.log(this.listPush)
    },
    read(form) {

      this.form = form;
      this.addFlag = 0;
      let data = {
        token: this.$store.state.authority_management,
        section_id: form.id
      }
      // // console.log(form)
      this.$post('section_products/search', data).then(res => {
        // // console.log(res.data.result);
        this.form.product = res.data.result;
        this.dialogFormRead = true;
      })
      // let arr=form.product.map(res=>{
      //   let json={};
      //   json.label=res.id;
      //   json.value=res.name;
      //   return json;
      // })
      // this.formSelected = arr;

    },
    //更新版块产品
    save(row) {
      if (row.name == '' || row.name == undefined) {
        this.$message({
          showClose: true,
          message: '版块名称不为空',
          type: 'error'
        });
        return false
      }
      else if (row.desc == '' || row.desc == undefined) {
        this.$message({
          showClose: true,
          message: '版块详情不为空',
          type: 'error'
        });
        return false
      }
      else if (!row.sort.match(/^\+?[1-9][0-9]*$/g)) {
        this.$message({
          showClose: true,
          message: '版块序号只能为正整数',
          type: 'error'
        });
        return false
      }
      this.dialogFormVisible = false;
      // // console.log(this.$store.state.store.id)
      if (this.addFlag == 1) {
        this.$post('sections/create', { token: this.$store.state.authority_management, name: row.name, desc: row.desc, sort: row.sort, template: row.template, page: row.page, shop_id: this.$store.state.store.id }).then(res => {
          this.$message({
            showClose: true,
            message: '版块添加成功',
            type: 'success'
          });
          this.getData();
        })

      }
      else {
        let data = {
          token: this.$store.state.authority_management,
          name: row.name,
          desc: row.desc,
          sort: row.sort,
          id: row.id,
          template: row.template
        }
        this.$post('sections/shop_edit', data);
        this.$message({
          showClose: true,
          message: '版块信息更新成功',
          type: 'success'
        });
        this.getData();
      }
    },

    batchDelete() {
      // // console.log(111111)
      // // console.log(this.multipleSelection)
      this.$confirm('此操作将删除该活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        for (vals of this.multipleSelection) {
          this.$post('sections/shop_delete', { token: this.$store.state.authority_management, id: vals.id })
        }
        this.getData();
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },

    //板块配置
    changProduct(row) {
      // 把当前板块的id保存好
      this.currentSectionId = row.id;
      this.getCurrentSectionProducts(row.id)


      // // console.log(row);
      // this.formSelected = [];
      // for(let val of row.product){
      //   let obj = {};
      //   obj.codeValue = val.id;
      //   obj.value = val.name;
      //   this.formSelected.push(obj);
      //   this.loadSelected.push(obj)
      // }
      // this.section_flag = row.id
      this.dialogProd = true;

      // 查询该板块下的所有项目包
      this.getPlateProjectPackage()
    },

    upProList() {
      // // console.log(this.formSelected)
      // // console.log(this.loadSelected)
      let addproduct = this.loadSelected.concat(this.formSelected).filter(v => !this.loadSelected.includes(v))
      let delproduct = this.loadSelected.concat(this.formSelected).filter(v => !this.formSelected.includes(v))
      // // console.log(addproduct,delproduct)

      for (let val of addproduct) {
        this.$post('section_products/create', { token: this.$store.state.authority_management, section_id: this.section_flag, product_id: val.codeValue })
      };
      for (let val2 of delproduct) {
        this.$post('section_products/delete', { token: this.$store.state.authority_management, section_id: this.section_flag, product_id: val2.id })
      }
      this.dialogProd = false
    },
    handleSizeChange(val) {
      // // console.log(`每页 ${val} 条`);
      this.productLen = val;
      this.getData();
    },
    handleCurrentChange(val) {
      // // console.log(`当前页: ${val}`);
      this.offset = (val - 1) * this.productLen
      this.getData();
    },
    closeDialog() {
      this.formSelected = [];
      this.loadSelected = [];
      this.getData();
    },

    //获取当前板块的产品数组
    getCurrentSectionProducts(id) {
      let data = {
        token: this.$store.state.authority_management,
        section_id: id
      }
      this.$post('section_products/search', data).then(res => {
        this.currentProducts = res.data.result;
        // // console.log(this.currentProducts)
      })
    },

    // 获取所有项目包数据
    getProjectPackageData() {
      const data = {
        token: this.$store.state.authority_management,
        offset: 0,
        length: 9999,
        name: null,
        shop_id: this.$store.state.store.id
      }
      this.$post('package/shop_search', data).then(res => {
        if (res.status === 200) {
          this.projectPackageList = res.data.result.data
          // // console.log(this.projectPackageList)
        }
      })
    },

    // 获取当前板块的项目包
    getPlateProjectPackage() {
      const data = {
        token: this.$store.state.authority_management,
        offset: 0,
        length: 9999,
        section_id: this.currentSectionId
      }
      this.$post('package_section/shop_search', data).then(res => {
        if (res.status === 200) {
          this.plateProjectPackageList = res.data.result.data
          // // console.log(this.plateProjectPackageList)
        }
      })
    },

    // 项目包选中的值发生变化时触发
    // value: 目前选中的值
    handleChange(value) {

    },

    // 添加项目包
    addProjectPackage(packageId) {
      // // console.log(packageId)
      if (packageId == '') {
        this.$message({
          type: 'error',
          message: '请选择对应的项目包名称'
        });
        return;
      }
      const data = {
        token: this.$store.state.authority_management,
        package_id: packageId,
        section_id: this.currentSectionId
      }
      // // console.log(data)
      this.$post('package_section/shop_create', data).then(res => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: '添加成功'
          })
          this.currentSelectdProjectPackage = ''
          this.getPlateProjectPackage(this.currentSectionId)
        } else {
          this.$message({
            type: 'success',
            message: '添加失败'
          })
        }
      })
    },

    // 删除项目包
    delProjectPackage(row) {
      // // console.log(row.id)
      this.$confirm('此操作将删除该项目包, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post('package_section/shop_delete', {
          token: this.$store.state.authority_management,
          id: row.id,
        }).then(res => {
          if (res.status === 200) {
            this.$message({
              type: 'success',
              message: '删除项目包成功'
            });
            this.getPlateProjectPackage(this.currentSectionId)
          } else {
            this.$message({
              type: 'error',
              message: '删除项目包失败'
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }



  },
  mounted: function () {
    // // console.log(this.$store.state.store.id)
    this.getData();
    this.getProduct();
    this.getProjectPackageData()
  },
  computed: {

  },
}